import React, { useState } from "react";
import countries from "../data/countries";
import { createSquad } from "../api/api";

const CreateSquadForm = ({ squadsCount, onCreated }) => {

    const [name, setName] = useState("");
    const [country, setCountry] = useState(countries[0]);
    const [creating, setCreating] = useState(false);
    const [error, setError] = useState(null);

    const handleCreateSquad = async () => {

        if (!name.trim()) {
            setError("Name is required");
            return;
        }

        try {
            setCreating(true);
            setError(null);

            await createSquad(
                name,
                country
            );

            setName("");

            await onCreated();

        } catch (err) {
            setError(err.message);
        } finally {
            setCreating(false);
        }
    };

    return (
        <div className="create-squad-section">

            <h2 className="squads-title">
                Create New Squad
            </h2>

            <p className="squad-limit-info">
                Maximum 5 squads per user.
            </p>

            {squadsCount >= 5 ? (
                <p className="alert-text">
                    Maximum squads reached.
                </p>
            ) : (
                <div className="profile-form">

                    <div className="form-group">

                        <label>
                            Squad Name
                        </label>

                        <input
                            type="text"
                            maxLength={30}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>

                    <div className="form-group">

                        <label>
                            Country
                        </label>

                        <select
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                        >
                            {countries.map((c, index) => (
                                <option
                                    key={index}
                                    value={c}
                                >
                                    {c}
                                </option>
                            ))}
                        </select>
                    </div>

                    {error && (
                        <p className="alert-text">
                            {error}
                        </p>
                    )}

                    <button
                        className="submit-button"
                        onClick={handleCreateSquad}
                        disabled={creating}
                    >
                        {creating
                            ? "Creating..."
                            : "Create Squad"}
                    </button>
                </div>
            )}
        </div>
    );
};

export default CreateSquadForm;